/* ============================================================
   EXON cards island — quick-add delegation for product cards.
   One document-level listener handles every [data-quick-add] on
   the page (home rails, catalog grid, vendor hubs). Uses the
   runtime contract: EXON.cart.add({ id, quantity }). Idempotent —
   guards against double-init when loaded by more than one section.
   ============================================================ */
(function () {
  'use strict';
  if (window.__exonCardsInit) return;
  window.__exonCardsInit = true;

  /* campaign cashback on cards: the server prints the campaign rate only
     before the end (snippets/cb-campaign.liquid) and marks the chip
     [data-cbc-card data-cbc-ends data-cbc-base]. A page cached from before
     the end, or left open across it, returns every marked chip to the store
     rate at the end time — the SSR cards and the ones placements.js draws. */
  (function () {
    var MAX_WAIT = 2147483647;
    function flipEnded() {
      var now = Date.now(), next = Infinity;
      Array.prototype.forEach.call(document.querySelectorAll('[data-cbc-card]'), function (el) {
        var ends = parseInt(el.getAttribute('data-cbc-ends'), 10);
        if (!(ends > 0)) return;
        if (now >= ends) {
          el.textContent = el.getAttribute('data-cbc-base') || '';
          el.removeAttribute('data-cbc-card');
          el.removeAttribute('data-cbc-ends');
        } else if (ends < next) {
          next = ends;
        }
      });
      return next;
    }
    function cfgEnd() {
      try {
        var el = document.getElementById('exon-placements-cfg');
        var c = el && JSON.parse(el.textContent);
        var e = c && c.cbCampaign && parseInt(c.cbCampaign.endsAt, 10);
        return e > 0 ? e : Infinity;
      } catch (e) { return Infinity; }
    }
    var timer = null;
    function arm() {
      if (timer) { clearTimeout(timer); timer = null; }
      var next = Math.min(flipEnded(), cfgEnd());
      if (next === Infinity) return;
      var wait = next - Date.now();
      if (wait <= 0) { flipEnded(); return; }
      timer = setTimeout(arm, Math.min(wait + 50, MAX_WAIT));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
    else arm();
    /* a tab that slept through the end, or a page restored from bfcache */
    document.addEventListener('visibilitychange', function () { if (!document.hidden) arm(); });
    window.addEventListener('pageshow', arm);
  })();

  document.addEventListener('click', function (e) {
    var t = e.target;

    /* quick-add on a product card */
    var btn = t.closest && t.closest('[data-quick-add]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('[data-product-card]');
      var id = card && card.getAttribute('data-variant-id');
      if (!id || !window.EXON || !window.EXON.cart) return;
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      window.EXON.cart
        .add({ id: Number(id), quantity: 1 })
        .catch(function () { /* surfaced by the cart drawer / toast island */ })
        .then(function () { btn.removeAttribute('aria-busy'); });
      return;
    }

    /* copy a drop discount code (the dashed voucher chip) */
    var chip = t.closest && t.closest('[data-copy-code]');
    if (chip) {
      e.preventDefault();
      e.stopPropagation();
      var code = chip.getAttribute('data-copy-code') || '';
      var done = function () {
        chip.classList.add('ok');
        setTimeout(function () { chip.classList.remove('ok'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    }
  });

  /* ------------------------------------------------------------
     Hover screenshot-motion (OWNER LOCKED — mockup ProductCard.tsx):
     cards carry up to 3 extra images in data-ss (pipe-separated).
     On mouseenter of the poster (.art) we mount <span class="ss-motion">
     with the imgs (Ken-Burns cycle lives in cards.css); on mouseleave
     the span is removed — exactly the mockup's mount/unmount. Gated on
     fine pointers; reduced-motion is handled in CSS (display:none).
     ------------------------------------------------------------ */
  var FINE_POINTER =
    window.matchMedia &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (FINE_POINTER) {
    var artOf = function (target, related) {
      if (!target || !target.closest) return null;
      var art = target.closest('[data-product-card][data-ss] .art');
      /* ignore moves within the same poster (mouseover/out bubble) */
      if (!art || (related && art.contains(related))) return null;
      return art;
    };

    document.addEventListener('mouseover', function (e) {
      var art = artOf(e.target, e.relatedTarget);
      if (!art || art.querySelector('.ss-motion')) return;
      var card = art.closest('[data-product-card]');
      var urls = (card.getAttribute('data-ss') || '')
        .split('|')
        .filter(Boolean)
        .slice(0, 3);
      if (!urls.length) return;
      var span = document.createElement('span');
      span.className = 'ss-motion';
      span.setAttribute('aria-hidden', 'true');
      urls.forEach(function (u) {
        var img = document.createElement('img');
        img.src = u;
        img.alt = '';
        span.appendChild(img);
      });
      /* insert right after the cover image — badges (.pct-art) and the
         quick-add button share z-index:2 and must stay painted above,
         same DOM order as the mockup */
      var cover = art.firstElementChild;
      art.insertBefore(span, cover ? cover.nextSibling : null);
      /* double rAF so the opacity transition in .ss-motion.on runs */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          span.classList.add('on');
        });
      });
    });

    document.addEventListener('mouseout', function (e) {
      var art = artOf(e.target, e.relatedTarget);
      if (!art) return;
      var span = art.querySelector('.ss-motion');
      if (span && span.parentNode) span.parentNode.removeChild(span);
    });
  }
})();
